if (typeof QHGraphic == "undefined") {
    var QHGraphic = {};
}

QHGraphic.Module = {
    winWidth: $(window).width(),
    winHeight: $(window).height(),
    scrollTop: $(window).scrollTop(),
    init: function () {
        this.createBannerSlider();
        this.createBannerParallax();
        this.createGalleryModules();
        this.revealImagesOnScroll();
        this.animateTextFadeInChars();
        this.createBannerModuleSliders();
        this.createVideoModules();
        this.createServicesShowcase();
        this.createParallaxBackgrounds();
        this.animateNewsEvents();
        this.windowScrollTop();

        /* Menu */
        var btnMenu = $('.btn-nav-menu');

        if (btnMenu.length) {
            var event = "click";

            if ($('html').hasClass('mobile')) {
                event = 'touchstart';
            }

            $(document).on(event, '.btn-nav-menu', function () {
                if ($('html').hasClass('nav-open')) {
                    $('html').removeClass('nav-open');
                } else {
                    setTimeout(function () {
                        $('html').addClass('nav-open');
                    }, 100);
                }
            });

            $(document).on(event, '.btn-close-menu', function () { 
                btnMenu.trigger('click');
            });
        }
    },
    /**
     * Khởi tạo banner slideshow bằng Swiper. Dùng .each() trên từng block
     * '.block-banner-slider' nên hỗ trợ multi slider trên cùng 1 trang - mỗi
     * block có module_ID riêng (do controller sinh ra), navigation/pagination
     * được scope theo đúng instance của nó (tránh 2 slider tranh nhau nút bấm).
     */
    createBannerSlider: function () {
        var self = this;

        if (typeof Swiper === 'undefined') {
            return;
        }

        $('.block-banner-slider').each(function () {
            var wrapper = $(this);
            var module_ID = wrapper.attr('data-banner-module');
            var sliderEl = wrapper.find('.createBannerSliders' + module_ID);

            if (!sliderEl.length) {
                return;
            }

            // loop/autoplay chỉ có ý nghĩa khi có từ 2 slide trở lên - banner chỉ có
            // 1 ảnh thì bật loop sẽ vô nghĩa và Swiper luôn in ra "Loop Warning" ở console
            var slideCount = sliderEl.find('.swiper-slide').length;
            var canLoop = slideCount > 1;

            var bannerSwiper = new Swiper(sliderEl.get(0), {
                speed: 800,
                loop: canLoop,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                autoplay: canLoop ? {
                    delay: 5000,
                    disableOnInteraction: false
                } : false,
                navigation: {
                    prevEl: sliderEl.find('.swiper-button-prev').get(0),
                    nextEl: sliderEl.find('.swiper-button-next').get(0)
                },
                on: {
                    init: function () {
                        var activeSlide = $(this.slides[this.activeIndex]);
                        self.animateStaggerFadeUp(activeSlide, '.caption .slogan-txt');
                    },
                    // slideChangeTransitionStart: ẩn ngay caption của slide sắp rời đi (không chờ
                    // slide fade xong) và chạy hiệu ứng hiện caption của slide sắp active - tránh
                    // 2 caption chồng nhau. Tại thời điểm này activeIndex đã là slide sắp tới.
                    slideChangeTransitionStart: function () {
                        var leavingSlide = $(this.slides[this.previousIndex]);
                        var enteringSlide = $(this.slides[this.activeIndex]);

                        self.resetStaggerItems(leavingSlide, '.caption .slogan-txt');
                        self.animateStaggerFadeUp(enteringSlide, '.caption .slogan-txt');
                    }
                }
            });

            wrapper.data('swiperInstance', bannerSwiper);
        });
    },
    /**
     * Slider của module banner (kiểu hiển thị "slider" trong admin): đọc cấu hình Swiper
     * từ data-swiper do controller dựng sẵn, nút và pagination scope theo từng block.
     */
    createBannerModuleSliders: function () {
        var self = this;

        if (typeof Swiper === 'undefined') {
            return;
        }

        var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // Hiệu ứng chữ chỉ chạy khi mỗi lần hiện 1 slide: nhiều slide cùng lúc thì chỉ slide active
        // có caption, các slide khác đang hiển thị sẽ bị mất chữ
        var isSingleView = function (swiper) {
            return parseFloat(swiper.params.slidesPerView) === 1;
        };

        $('[data-banner-slider]').each(function () {
            var $module = $(this);
            var $slider = $module.find('[data-swiper]');

            if (!$slider.length) {
                return;
            }

            var config = $slider.data('swiper') || {};
            var $pagination = $slider.find('.swiper-pagination');
            var $prev = $module.find('.swiper-button-prev');
            var $next = $module.find('.swiper-button-next');

            if ($pagination.length) {
                config.pagination = {
                    el: $pagination.get(0),
                    type: $pagination.data('type'),
                    clickable: true
                };
            }

            if ($prev.length && $next.length) {
                config.navigation = {
                    prevEl: $prev.get(0),
                    nextEl: $next.get(0)
                };
            }

            if (!prefersReducedMotion && typeof gsap !== 'undefined') {
                config.on = {
                    init: function () {
                        if (!isSingleView(this)) {
                            return;
                        }

                        $.each(this.slides, function () {
                            self.resetBannerCaption($(this));
                        });

                        self.playBannerCaption($(this.slides[this.activeIndex]));
                    },
                    // Lúc này activeIndex đã là slide sắp tới: ẩn ngay caption slide cũ, chạy caption slide mới
                    slideChangeTransitionStart: function () {
                        if (!isSingleView(this)) {
                            return;
                        }

                        self.resetBannerCaption($(this.slides[this.previousIndex]));
                        self.playBannerCaption($(this.slides[this.activeIndex]));
                    },
                    // Đổi breakpoint sang nhiều slide/màn hình: hiện lại toàn bộ caption
                    breakpoint: function (swiper) {
                        if (!isSingleView(swiper)) {
                            gsap.set($(swiper.el).find('.aniWords__char, .banner-module__desc'), { opacity: 1, y: 0 });
                        }
                    }
                };
            }

            $slider.data('swiperInstance', new Swiper($slider.get(0), config));
        });
    },
    /**
     * Caption slide banner: tiêu đề chạy hiệu ứng aniWords (hiện dần từng chữ cái, tách chữ bằng
     * splitTextChars), mô tả fade-up ngay sau đó.
     *
     * @param {jQuery} slide  slide sắp active
     */
    playBannerCaption: function (slide) {
        var title = slide.find('.banner-module__title');

        if (title.length) {
            var chars = this.splitTextChars(title.get(0));

            // Stagger ngắn hơn aniWords toàn trang để tiêu đề dài vẫn hiện xong trước khi đổi slide
            gsap.fromTo(chars, { opacity: 0 }, {
                opacity: 1,
                duration: 0.6,
                stagger: 0.04,
                ease: 'power2.out',
                delay: 0.2,
                overwrite: true
            });
        }

        this.animateStaggerFadeUp(slide, '.banner-module__desc', { distance: 20, delay: 0.6 });
    },
    /**
     * Ẩn ngay caption của slide (không animation) để lần active sau chạy lại hiệu ứng từ đầu.
     *
     * @param {jQuery} slide  slide vừa rời đi
     */
    resetBannerCaption: function (slide) {
        var title = slide.find('.banner-module__title');

        if (title.length) {
            var chars = this.splitTextChars(title.get(0));

            gsap.killTweensOf(chars);
            gsap.set(chars, { opacity: 0 });
        }

        this.resetStaggerItems(slide, '.banner-module__desc', { distance: 20 });
    },
    /**
     * Hiệu ứng parallax cho ảnh module banner (extension/module/banner) bằng Rellax:
     * lớp ảnh của kiểu List ('.services__banner-media') và Slider ('.banner-module__media')
     * cuộn chậm hơn trang. Tốc độ lấy từ data-rellax-speed.
     * Bỏ qua khi người dùng bật giảm chuyển động.
     */
    createBannerParallax: function () {
        var selector = '.services__banner .rellax, .banner-module__media.rellax, .services .rellax';

        if (typeof Rellax === 'undefined' || !$(selector).length) {
            return;
        }

        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            return;
        }

        this.bannerParallax = new Rellax(selector, {
            center: true,
            round: true
        });
    },
    /**
     * Hàm dùng chung: chạy hiệu ứng fade-up so le (stagger) bằng GSAP cho các phần tử
     * con của 1 container. Dùng cho caption slideshow, và tái sử dụng được cho bất kỳ
     * khối nội dung nào khác cần hiệu ứng khi active/hiển thị (banner, section, card...).
     *
     * @param {jQuery} container   phần tử cha chứa các item cần chạy hiệu ứng
     * @param {String} itemsSelector selector (trong container) của các item chạy so le
     * @param {Object} [options]   tuỳ chỉnh: distance, duration, stagger, ease, delay
     */
    animateStaggerFadeUp: function (container, itemsSelector, options) {
        if (typeof gsap === 'undefined' || !container || !container.length) {
            return;
        }

        var items = container.find(itemsSelector);

        if (!items.length) {
            return;
        }

        var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (prefersReducedMotion) {
            gsap.set(items, { y: 0, opacity: 1 });
            return;
        }

        var settings = $.extend({
            distance: 50,
            duration: 0.8,
            stagger: 0.15,
            ease: 'power2.out',
            delay: 0.5
        }, options);

        gsap.fromTo(items, {
            y: settings.distance,
            opacity: 0
        }, {
            y: 0,
            opacity: 1,
            duration: settings.duration,
            stagger: settings.stagger,
            ease: settings.ease,
            delay: settings.delay,
            overwrite: true
        });
    },
    /**
     * Hàm dùng chung: hiệu ứng fade-in (chỉ đổi opacity, không dịch chuyển) cho mọi phần tử
     * có class 'showed-fade' khi cuộn tới. Chính phần tử hiện trước, sau đó các thẻ con
     * trực tiếp (div, p, article, section, span, heading, list, ảnh...) hiện so le lần lượt.
     * Thẻ con cũng mang class 'showed-fade' được bỏ qua ở cấp cha vì nó tự chạy hiệu ứng riêng.
     *
     * @param {String|jQuery} [selector] phần tử cần hiệu ứng (mặc định '.showed-fade')
     * @param {Object} [options] tuỳ chỉnh: duration, stagger, ease, delay, childDelay,
     *                           childTags, scroll (false = chạy ngay), start
     */
    animateStaggerFadeIn: function (selector, options) {
        if (typeof gsap === 'undefined') {
            return;
        }

        var ownSelector = typeof selector === 'string' ? selector : '.showed-fade';
        var elements = selector ? $(selector) : $('.showed-fade');

        if (!elements.length) {
            return;
        }

        var settings = $.extend({
            duration: 0.8,
            stagger: 0.15,
            ease: 'power1.out',
            delay: 0,
            childDelay: 0.2,
            childTags: 'div, p, article, section, span, h1, h2, h3, h4, h5, h6, ul, ol, li, figure, img, a, blockquote',
            scroll: true,
            start: 'top 85%'
        }, options);

        var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var useScroll = settings.scroll && typeof ScrollTrigger !== 'undefined';

        if (useScroll) {
            gsap.registerPlugin(ScrollTrigger);
        }

        elements.each(function () {
            var el = $(this);
            var children = el.children(settings.childTags).not(ownSelector);

            if (prefersReducedMotion) {
                gsap.set(el.add(children), { opacity: 1 });
                return;
            }

            gsap.set(el.add(children), { opacity: 0 });

            var play = function () {
                var timeline = gsap.timeline({ delay: settings.delay });

                timeline.to(el, {
                    opacity: 1,
                    duration: settings.duration,
                    ease: settings.ease
                });

                // Nội dung con bắt đầu hiện sau childDelay giây, không chờ phần tử cha hiện xong
                if (children.length) {
                    timeline.to(children, {
                        opacity: 1,
                        duration: settings.duration,
                        stagger: settings.stagger,
                        ease: settings.ease
                    }, settings.childDelay);
                }
            };

            if (useScroll) {
                ScrollTrigger.create({
                    trigger: this,
                    start: settings.start,
                    once: true,
                    onEnter: play
                });
            } else {
                play();
            }
        });
    },
    /**
     * Hiệu ứng xuất hiện cho khối tin sự kiện (.news-events) ở trang danh mục tin:
     * ảnh mở ra từ dưới lên (clip-path), badge ngày rơi xuống, tiêu đề hiện dần,
     * nút tròn "Xem chi tiết" xoay vào. Bài nổi bật chạy trước, 2 bài nhỏ so le theo sau.
     * Chỉ tween các phần tử KHÔNG có CSS transition (media, date, title, more) - img và
     * vòng chữ đã có transition transform cho hover, tween trực tiếp sẽ bị giật.
     *
     * @param {String} [selector] khối cần hiệu ứng (mặc định '.news-events')
     */
    animateNewsEvents: function (selector) {
        if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
            return;
        }

        var section = $(selector || '.news-events');

        if (!section.length) {
            return;
        }

        var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (prefersReducedMotion) {
            return;
        }

        gsap.registerPlugin(ScrollTrigger);

        section.find('.news-events__item').each(function (index) {
            var item = $(this);
            var media = item.find('.news-events__media');
            var date = item.find('.news-events__date');
            var title = item.find('.news-events__title');
            var more = item.find('.news-events__more');
            var hiddenClip = 'inset(100% 0% 0% 0% round 12px)';
            var shownClip = 'inset(0% 0% 0% 0% round 12px)';

            gsap.set(media, { clipPath: hiddenClip });
            gsap.set(date, { y: -16, opacity: 0 });
            gsap.set(title, { y: 16, opacity: 0 });

            if (more.length) {
                gsap.set(more, { scale: 0.4, rotation: -90, opacity: 0 });
            }

            var timeline = gsap.timeline({
                paused: true,
                // 2 bài nhỏ nằm cùng hàng: bài bên phải trễ hơn một nhịp để tạo cảm giác so le
                delay: item.hasClass('news-events__item--featured') ? 0 : (index % 2 === 0 ? 0.15 : 0),
                onComplete: function () {
                    gsap.set(media.add(date).add(title).add(more), { clearProps: 'all' });
                }
            });

            timeline
                .to(media, { clipPath: shownClip, duration: 1, ease: 'power3.inOut' })
                .to(date, { y: 0, opacity: 1, duration: 0.5, ease: 'back.out(2)' }, '-=0.35')
                .to(title, { y: 0, opacity: 1, duration: 0.6, ease: 'power2.out' }, '-=0.3');

            if (more.length) {
                timeline.to(more, { scale: 1, rotation: 0, opacity: 1, duration: 0.8, ease: 'back.out(1.6)' }, '-=0.45');
            }

            ScrollTrigger.create({
                trigger: this,
                start: 'top 85%',
                once: true,
                onEnter: function () {
                    timeline.play();
                }
            });
        });
    },
    /**
     * Hàm dùng chung: ẩn ngay lập tức (không animation) các item trong 1 container -
     * dùng để reset về trạng thái ban đầu của animateStaggerFadeUp khi content không
     * còn active nữa, tránh bị lưu lại hình ảnh cũ đè lên content mới.
     *
     * @param {jQuery} container   phần tử cha chứa các item cần ẩn
     * @param {String} itemsSelector selector (trong container) của các item cần ẩn
     * @param {Object} [options]   tuỳ chỉnh: distance
     */
    resetStaggerItems: function (container, itemsSelector, options) {
        if (typeof gsap === 'undefined' || !container || !container.length) {
            return;
        }

        var items = container.find(itemsSelector);

        if (!items.length) {
            return;
        }

        var settings = $.extend({
            distance: 30
        }, options);

        gsap.killTweensOf(items);
        gsap.set(items, { y: settings.distance, opacity: 0 });
    },
    /**
     * Hàm dùng chung: hiệu ứng xuất hiện hình ảnh khi cuộn tới - áp dụng cho mọi
     * phần tử có class 'showed-pic' trên toàn site (gallery, section ảnh...).
     * Dùng GSAP ScrollTrigger.batch() nên các ảnh cuộn tới cùng lúc sẽ hiện so le
     * theo đúng thứ tự trong DOM, không cần khai báo riêng cho từng trang.
     *
     * @param {String} [selector]  selector các phần tử cần hiệu ứng (mặc định '.showed-pic')
     * @param {Object} [options]   tuỳ chỉnh: distance, duration, stagger, ease, start
     */
    revealImagesOnScroll: function (selector, options) {
        if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
            return;
        }

        gsap.registerPlugin(ScrollTrigger);

        var items = $(selector || '.showed-pic');

        if (!items.length) {
            return;
        }

        var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (prefersReducedMotion) {
            gsap.set(items, { y: 0, opacity: 1 });
            return;
        }

        var settings = $.extend({
            distance: 60,
            duration: 0.7,
            stagger: 0.15,
            ease: 'power2.out',
            start: 'top 85%'
        }, options);

        gsap.set(items, { y: settings.distance, opacity: 0 });

        ScrollTrigger.batch(items.toArray(), {
            start: settings.start,
            once: true,
            onEnter: function (batch) {
                gsap.to(batch, {
                    y: 0,
                    opacity: 1,
                    duration: settings.duration,
                    stagger: settings.stagger,
                    ease: settings.ease,
                    overwrite: true
                });
            }
        });
    },
    /**
     * Helper cho animateTextFadeInChars(): tách text của 1 phần tử thành từng ký tự,
     * bọc mỗi ký tự (trừ khoảng trắng) trong span.aniWords__char - giữ nguyên khoảng
     * trắng dạng text node để trình duyệt tự ngắt dòng đúng theo từ, không vỡ chữ giữa
     * dòng. Toàn bộ span ký tự được bọc chung trong 1 span.aniWords__inner duy nhất
     * (thay vì chèn thẳng vào phần tử gốc) - vì '.heading__title' dùng
     * display:flex nên nếu để các span ký tự làm con trực tiếp, mỗi ký tự sẽ bị
     * flexbox coi là 1 flex item riêng và các khoảng trắng (text node thuần
     * whitespace) giữa chúng sẽ bị trình duyệt ẩn đi theo spec Flexbox. Cache lại
     * kết quả trên phần tử (qua .data()) để gọi lại không bị tách 2 lần.
     *
     * @param {HTMLElement} el  phần tử chứa text cần tách
     * @return {jQuery} tập hợp các span ký tự đã tách
     */
    splitTextChars: function (el) {
        var node = $(el);
        var cached = node.data('aniWordsChars');

        if (cached) {
            return cached;
        }

        var text = node.text();
        var html = '';

        $.each(text.split(''), function (i, char) {
            // text() đã decode entity: escape lại trước khi ghép vào HTML
            html += char === ' ' ? ' ' : '<span class="aniWords__char">' + $('<span>').text(char).html() + '</span>';
        });

        node.html('<span class="aniWords__inner">' + html + '</span>');

        var chars = node.find('.aniWords__char');
        node.data('aniWordsChars', chars);

        return chars;
    },
    /**
     * Hàm dùng chung: hiệu ứng fade-in từng chữ cái (letter-by-letter) bằng GSAP cho
     * mọi phần tử có class 'aniWords' (heading, title...). Tách text bằng
     * splitTextChars() rồi chạy stagger fade-in khi cuộn tới - tái sử dụng được cho
     * bất kỳ khối text nào cần nhấn hiệu ứng chạy chữ, không cần khai báo riêng
     * cho từng trang.
     *
     * @param {String} [selector]  selector các phần tử cần hiệu ứng (mặc định '.aniWords')
     * @param {Object} [options]   tuỳ chỉnh: duration, stagger, ease, start,
     *                             activateAt (tiến độ 0-1 để gắn class 'aniActivated', mặc định 0.8)
     */
    animateTextFadeInChars: function (selector, options) {
        if (typeof gsap === 'undefined') {
            return;
        }

        var elements = $(selector || '.aniWords');

        if (!elements.length) {
            return;
        }

        var self = this;
        var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        var settings = $.extend({
            duration: 0.5,
            stagger: 0.15,
            ease: 'power2.out',
            start: 'top 90%',
            activateAt: 0.8
        }, options);

        elements.each(function () {
            var element = $(this);
            var chars = self.splitTextChars(this);

            if (!chars.length) {
                return;
            }

            if (prefersReducedMotion) {
                gsap.set(chars, { opacity: 1 });
                element.addClass('aniActivated');
                return;
            }

            gsap.set(chars, { opacity: 0 });

            var runAnimation = function () {
                gsap.to(chars, {
                    opacity: 1,
                    duration: settings.duration,
                    stagger: settings.stagger,
                    ease: settings.ease,
                    overwrite: true,
                    onUpdate: function () {
                        if (this.progress() >= settings.activateAt) {
                            element.addClass('aniActivated');
                        }
                    },
                    onComplete: function () {
                        element.addClass('aniActivated');
                    }
                });
            };

            if (typeof ScrollTrigger !== 'undefined') {
                gsap.registerPlugin(ScrollTrigger);

                ScrollTrigger.create({
                    trigger: this,
                    start: settings.start,
                    once: true,
                    onEnter: runAnimation
                });
            } else {
                runAnimation();
            }
        });
    },
    /**
     * Chạy callback khi preloader (preloader.js) đã ẩn. Trang không có preloader,
     * hoặc preloader đã xong trước khi gọi hàm này, thì callback chạy ngay.
     *
     * @param {Function} callback
     */
    whenPreloaderDone: function (callback) {
        var root = document.documentElement;

        if (!document.getElementById('preloader') || root.getAttribute('data-preloader') === 'done') {
            callback();
            return;
        }

        document.addEventListener('preloader:done', function onDone() {
            document.removeEventListener('preloader:done', onDone);
            callback();
        });
    },
    /**
     * Tạm dừng toàn bộ GSAP cho tới khi preloader ẩn. Các module vẫn khởi tạo bình thường
     * (gsap.set trạng thái ẩn, ScrollTrigger đăng ký, tween của phần tử đang trong màn hình
     * được tạo) nhưng global timeline đứng yên nên không tween nào chạy sau lớp preloader -
     * hiệu ứng đầu trang bắt đầu đúng lúc người dùng nhìn thấy nội dung.
     * Phải gọi trước init() để không tween nào kịp chạy.
     */
    holdAnimationsUntilPreloaderDone: function () {
        if (typeof gsap === 'undefined') {
            return;
        }

        gsap.globalTimeline.pause();

        this.whenPreloaderDone(function () {
            gsap.globalTimeline.resume();

            // #site-content vừa bỏ translateY của preloader: tính lại vị trí trigger
            if (typeof ScrollTrigger !== 'undefined') {
                ScrollTrigger.refresh();
            }
        });
    },
    windowScrollTop: function () {
        $(window).scroll(function () {
            const scrollTop = $(window).scrollTop();
            const docHeight = $(document).height();
            const winHeight = $(window).height();

            if (scrollTop + winHeight >= docHeight - 100) {
                $('.chatButtons').addClass('fixFooter');   
            } else {
                $('.chatButtons').removeClass('fixFooter');   
            }
        });

        $('#backToTop a').on('click', function (e) {
            e.preventDefault();
            
            $('body, html').animate({
                scrollTop: 0
            }, 300);

            return false;
        });
    },
    /**
     * Module gallery (extension/module/gallery): mỗi block tự đọc cấu hình Swiper từ
     * data-swiper (controller dựng sẵn từ cấu hình admin), nút/pagination scope theo block.
     * Mọi ảnh mở lightbox Magnific Popup ở chế độ gallery để lướt qua toàn bộ ảnh của block.
     */
    createGalleryModules: function () {
        $('[data-gallery-module]').each(function () {
            var $module = $(this);
            var $slider = $module.find('[data-swiper]');

            if ($slider.length && typeof Swiper !== 'undefined') {
                var config = $slider.data('swiper') || {};
                var $pagination = $slider.find('.swiper-pagination');
                var $prev = $module.find('.gallery-module__nav--prev');
                var $next = $module.find('.gallery-module__nav--next');

                if ($pagination.length) {
                    config.pagination = {
                        el: $pagination.get(0),
                        type: $pagination.data('type'),
                        clickable: true
                    };
                }

                if ($prev.length && $next.length) {
                    config.navigation = {
                        prevEl: $prev.get(0),
                        nextEl: $next.get(0)
                    };
                }

                $slider.data('swiperInstance', new Swiper($slider.get(0), config));
            }

            if (typeof $.fn.magnificPopup === 'function') {
                $module.magnificPopup({
                    delegate: 'a.gallery-module__link',
                    type: 'image',
                    tClose: $module.data('text-close'),
                    tLoading: $module.data('text-loading'),
                    mainClass: 'mfp-fade',
                    removalDelay: 200,
                    gallery: {
                        enabled: true,
                        tPrev: $module.data('text-prev'),
                        tNext: $module.data('text-next'),
                        tCounter: $module.data('text-counter')
                    },
                    image: {
                        tError: $module.data('text-error'),
                        // Magnific chèn title dạng HTML, chuyển về text để không render thẻ lạ
                        titleSrc: function (item) {
                            return $('<div>').text(item.el.attr('title') || '').html();
                        }
                    }
                });
            }
        });
    },
    /**
     * Hàm dùng chung: parallax cho lớp nền có thuộc tính data-parallax-bg, chạy theo thanh cuộn
     * (GSAP ScrollTrigger, scrub). Mốc cuộn là phần tử cha trực tiếp của lớp nền.
     * Lớp nền cần CSS dư ra trên/dưới lớn hơn biên độ (ví dụ inset: -15% 0 cho biên độ ±10%),
     * nếu không sẽ lộ mép. Giá trị data-parallax-bg="8" đổi biên độ (% chiều cao lớp nền), mặc định 10.
     */
    createParallaxBackgrounds: function () {
        if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
            return;
        }

        var layers = $('[data-parallax-bg]');

        if (!layers.length) {
            return;
        }

        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            return;
        }

        gsap.registerPlugin(ScrollTrigger);

        layers.each(function () {
            var distance = parseFloat($(this).attr('data-parallax-bg')) || 10;

            gsap.fromTo(this, { yPercent: -distance }, {
                yPercent: distance,
                ease: 'none',
                scrollTrigger: {
                    trigger: this.parentElement,
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: true
                }
            });
        });
    },
    /**
     * Module danh mục dịch vụ (extension/module/services_category_list): slider thẻ ảnh bằng Swiper,
     * danh mục đang chọn quyết định ảnh nền, panel nội dung bên trái, rail số, bộ đếm và thanh tiến trình.
     * Chỉ số hiện tại do module tự giữ thay vì dùng activeIndex của Swiper: khi hiện 3 thẻ/khung,
     * Swiper không trượt tới được thẻ cuối, còn loop tự tắt khi admin chọn ít danh mục.
     * Ảnh nền (trừ slide đầu) nằm ở data-src, chỉ tải khi slide đó (hoặc slide kế) được chọn.
     */
    createServicesShowcase: function () {
        if (typeof Swiper === 'undefined') {
            return;
        }

        $('[data-services-showcase]').each(function () {
            var $root = $(this);
            var $cards = $root.find('.services-showcase__card');
            var total = $cards.length;

            if (!total) {
                return;
            }

            var $panels = $root.find('.services-showcase__panel');
            var $backgrounds = $root.find('.services-showcase__bg');
            var $railButtons = $root.find('.services-showcase__rail-btn');
            var $counter = $root.find('[data-showcase-counter]');
            var current = 0;
            var isSyncing = false;
            var isDragging = false;

            var swiper = new Swiper($root.find('.services-showcase__swiper').get(0), {
                slidesPerView: 1.6,
                spaceBetween: 14,
                speed: 600,
                watchOverflow: true,
                breakpoints: {
                    768: { slidesPerView: 2.5, spaceBetween: 24 },
                    1024: { slidesPerView: 2.25, spaceBetween: 24 },
                    1200: { slidesPerView: 3, spaceBetween: 30 }
                }
            });

            var loadBackground = function (index) {
                var $image = $backgrounds.eq(index).find('img[data-src]');

                if ($image.length) {
                    $image.attr('src', $image.attr('data-src')).removeAttr('data-src');
                }
            };

            var formatCounter = function (number) {
                return number < 10 ? '0' + number : String(number);
            };

            var setActive = function (index, moveSlider) {
                current = (index + total) % total;

                loadBackground(current);
                loadBackground((current + 1) % total);

                $backgrounds.removeClass('is-active').eq(current).addClass('is-active');

                $panels.removeClass('is-active').attr('aria-hidden', 'true').find('a').attr('tabindex', '-1');
                $panels.eq(current).addClass('is-active').removeAttr('aria-hidden').find('a').removeAttr('tabindex');

                $cards.removeClass('is-active').attr('aria-pressed', 'false');
                $cards.eq(current).addClass('is-active').attr('aria-pressed', 'true');

                $railButtons.removeClass('is-active').removeAttr('aria-current');
                $railButtons.eq(current).addClass('is-active').attr('aria-current', 'true');

                $counter.text(formatCounter(current + 1));
                $root.get(0).style.setProperty('--showcase-progress', ((current + 1) / total * 100) + '%');

                if (moveSlider !== false) {
                    // slideTo() emits slideChange synchronously; the flag stops it from re-entering setActive
                    isSyncing = true;
                    swiper.slideTo(current);
                    isSyncing = false;
                }
            };

            // Follow slideChange only when the user swipes: a breakpoint change also recomputes
            // activeIndex and would otherwise jump the content to another category on resize.
            swiper.on('sliderFirstMove', function () {
                isDragging = true;
            });

            swiper.on('touchEnd', function () {
                // slideTo() runs right after the touchEnd event in the same tick, so reset afterwards
                setTimeout(function () {
                    isDragging = false;
                }, 0);
            });

            swiper.on('slideChange', function () {
                if (isDragging && !isSyncing) {
                    setActive(swiper.activeIndex, false);
                }
            });

            // 'resize' fires after Swiper re-measures ('breakpoint' fires before, with stale sizes)
            swiper.on('resize', function () {
                isSyncing = true;
                swiper.slideTo(current, 0);
                isSyncing = false;
            });

            $cards.on('click', function () {
                setActive(parseInt($(this).attr('data-index'), 10));
            });

            $railButtons.on('click', function () {
                setActive(parseInt($(this).attr('data-index'), 10));
            });

            $root.find('[data-showcase-prev]').on('click', function () {
                setActive(current - 1);
            });

            $root.find('[data-showcase-next]').on('click', function () {
                setActive(current + 1);
            });

            $root.on('keydown', function (event) {
                if (event.key === 'ArrowLeft') {
                    setActive(current - 1);
                } else if (event.key === 'ArrowRight') {
                    setActive(current + 1);
                }
            });

            loadBackground(1 % total);

            // Parallax moves the backdrop wrapper, not the images: they already transition transform for the slide zoom
            var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

            if (!prefersReducedMotion && typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
                gsap.registerPlugin(ScrollTrigger);

                gsap.fromTo($root.find('.services-showcase__backdrop').get(0), { yPercent: -10 }, {
                    yPercent: 10,
                    ease: 'none',
                    scrollTrigger: {
                        trigger: $root.get(0),
                        start: 'top bottom',
                        end: 'bottom top',
                        scrub: true
                    }
                });
            }
        });
    },
    /**
     * Module video (extension/module/video): slider Swiper như module gallery, click vào video
     * mở popup Magnific (chế độ gallery để chuyển qua lại). YouTube/Vimeo phát bằng iframe,
     * MP4 bằng thẻ <video>. Player được dựng bằng DOM API (không nối chuỗi HTML) và bị gỡ khỏi
     * DOM khi đóng/chuyển video nên tiếng không chạy ngầm.
     */
    createVideoModules: function () {
        $('[data-video-module]').each(function () {
            var $module = $(this);
            var $slider = $module.find('[data-swiper]');

            if ($slider.length && typeof Swiper !== 'undefined') {
                var config = $slider.data('swiper') || {};
                var $pagination = $slider.find('.swiper-pagination');
                var $prev = $module.find('.video-module__nav--prev');
                var $next = $module.find('.video-module__nav--next');

                if ($pagination.length) {
                    config.pagination = {
                        el: $pagination.get(0),
                        type: $pagination.data('type'),
                        clickable: true
                    };
                }

                if ($prev.length && $next.length) {
                    config.navigation = {
                        prevEl: $prev.get(0),
                        nextEl: $next.get(0)
                    };
                }

                $slider.data('swiperInstance', new Swiper($slider.get(0), config));
            }

            if (typeof $.fn.magnificPopup !== 'function') {
                return;
            }

            // Slider bật loop sẽ nhân bản slide: chỉ lấy link gốc để popup không lặp video
            var $links = $module.find('.video-module__link').filter(function () {
                return !$(this).closest('.swiper-slide-duplicate').length;
            });

            function buildPlayer($link) {
                var type = $link.data('video-type');
                var src = $link.data('video-src');
                var title = $link.data('video-title') || '';
                var $popup = $('<div class="video-popup" role="dialog" aria-modal="true"></div>').attr('aria-label', $module.data('text-popup') + (title ? ': ' + title : ''));
                var $frame = $('<div class="video-popup__frame"></div>');

                if ($module.hasClass('video-module--ratio-9-16')) {
                    $popup.addClass('video-popup--portrait');
                }

                if (type === 'video') {
                    $frame.append(
                        $('<video controls autoplay playsinline preload="metadata"></video>')
                            .attr('src', src)
                            .text($module.data('text-no-support'))
                    );
                } else {
                    $frame.append(
                        $('<iframe allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>')
                            .attr({ src: src, title: title })
                    );
                }

                $popup.append($frame);

                if (title) {
                    $popup.append($('<p class="video-popup__title"></p>').text(title));
                }

                return $popup;
            }

            function stopPlayers(content) {
                $(content).find('video').each(function () {
                    this.pause();
                });
            }

            $module.on('click', '.video-module__link', function (e) {
                e.preventDefault();

                var $clicked = $(this);
                var clickedSrc = $clicked.attr('data-video-src');
                var $original = $clicked.closest('.swiper-slide-duplicate').length
                    ? $links.filter(function () {
                        return $(this).attr('data-video-src') === clickedSrc;
                    }).first()
                    : $clicked;
                var index = Math.max(0, $links.index($original));

                $.magnificPopup.open({
                    items: $links.map(function () {
                        return { type: 'inline', link: this };
                    }).get(),
                    tClose: $module.data('text-close'),
                    tLoading: $module.data('text-loading'),
                    mainClass: 'mfp-fade mfp-video',
                    removalDelay: 200,
                    closeBtnInside: true,
                    gallery: {
                        enabled: $links.length > 1,
                        tPrev: $module.data('text-prev'),
                        tNext: $module.data('text-next'),
                        tCounter: $module.data('text-counter')
                    },
                    callbacks: {
                        // Chỉ dựng player khi video được hiển thị, tránh tải trước mọi file MP4
                        elementParse: function (item) {
                            item.src = buildPlayer($(item.data.link));
                        },
                        beforeChange: function () {
                            if (this.content) {
                                stopPlayers(this.content);
                            }
                        },
                        close: function () {
                            if (this.content) {
                                stopPlayers(this.content);
                            }
                        }
                    }
                }, index);
            });
        });
    },
    // Dùng chung cho trang Liên hệ và module Contact CTA: scope theo $form (không hardcode ID)
    // để nhiều form (module đặt ở nhiều vị trí) có thể cùng tồn tại trên một trang mà không đụng nhau.
    contactForm: function ($form) {
        var $wrapper = $form.closest('[data-contact-form]'),
            $button = $form.find('button[type="submit"]'),
            $alert = $form.find('.contact__alert'),
            $modal = $wrapper.find('.contact__modal').appendTo('body');

        function clearErrors() {
            $alert.empty();
            $form.find('.form-group').removeClass('has-error');
            $form.find('.input-field .text-danger').remove();
        }

        function showErrors(errors) {
            $.each(errors, function (field, message) {
                var $input = $form.find('[name="' + field + '"]');

                if (field !== 'warning' && $input.length) {
                    $input.closest('.form-group').addClass('has-error');
                    $input.after($('<div class="text-danger"></div>').text(message));
                } else {
                    $alert.append($('<div></div>').text(message));
                }
            });

            var $first = $form.find('.has-error [name]').first();

            if ($first.length) {
                $first.trigger('focus');
            }
        }

        $form.on('submit', function (e) {
            e.preventDefault();

            $.ajax({
                url: $form.attr('action'),
                type: 'post',
                data: $form.serialize(),
                dataType: 'json',
                beforeSend: function () {
                    clearErrors();
                    $button.button('loading');
                },
                success: function (json) {
                    if (json.error) {
                        $button.button('reset');
                        showErrors(json.error);

                        return;
                    }

                    if (json.success) {
                        $modal.find('.contact__modal-message').text(json.success);
                        $modal.modal('show');

                        setTimeout(function () {
                            $modal.modal('hide');
                        }, 5000);
                    }
                },
                error: function () {
                    $button.button('reset');
                    $alert.text($form.data('error-connection'));
                }
            });
        });

        // Reload cả khi tự đóng sau 5s lẫn khi người dùng đóng sớm: token của form cũ đã hết hạn
        $modal.on('hidden.bs.modal', function () {
            window.location.reload();
        });
    }
};

$(document).ready(function () {
    QHGraphic.Module.winWidth = $(window).width();
    QHGraphic.Module.holdAnimationsUntilPreloaderDone();
    QHGraphic.Module.init();

    $('.header').sticky({
        topSpacing: 0,
        zIndex: 99
    });

    // WOW (animate.css) không đi qua GSAP nên phải tự chờ preloader, nếu không các khối
    // đầu trang đã fadeIn xong phía sau lớp preloader
    QHGraphic.Module.whenPreloaderDone(function () {
        new WOW().init();
    });

    // Apply Image FadeInUp Animation
    QHGraphic.Module.revealImagesOnScroll('.text-showed', {
       distance: 20, 
       duration: 0.6 
    });

    // Apply Text FadeIn Animation
    QHGraphic.Module.animateStaggerFadeIn('.showed-fade', {
       distance: 20, 
       duration: 0.6 
    });

    $('[data-contact-form] form').each(function () {
        QHGraphic.Module.contactForm($(this));
    });

    // Parallax background effect (Rellax)
    if ($('#information-contact .rellax').length) {
        new Rellax('#information-contact .rellax', {
            speed: -2,
            center: true
        });
    }

    // Lazyload Image
    var lazyload = $('.lazyload');

    if (lazyload.length) {
        lazyload.lazy({
            defaultImage: false,
            afterLoad: function(element) {
                element.removeClass('lazyload').addClass('lazyloaded');
            }
        });
    }

    // Cache selectors
    var lastId,
        topMenu = $(".breadcrumbScroller"),
        topMenuHeight = topMenu.outerHeight() + 55,
        menuItems = topMenu.find("a"),
        scrollItems = menuItems.map(function() {
            var item = $($(this).attr("href"));
            
            if (item.length) { 
                return item; 
            }
        });

    // Bind click handler to menu items
    // so we can get a fancy scroll animation
    menuItems.click(function(e){
        var href = $(this).attr("href"),
            offsetTop = href === "#" ? 0 : $(href).offset().top-topMenuHeight+1;
            
            $('html, body').stop().animate({ 
                scrollTop: offsetTop
            }, 600);
            
            e.preventDefault();
    });

    // Bind to scroll
    $(window).scroll(function(){
       // Get container scroll position
       var fromTop = $(this).scrollTop()+topMenuHeight;
       
       // Get id of current scroll item
       var cur = scrollItems.map(function(){
            if ($(this).offset().top < fromTop)
            return this;
       });

       // Get the id of the current element
       cur = cur[cur.length-1];
       var id = cur && cur.length ? cur[0].id : "";
       
       if (lastId !== id) {
           lastId = id;
           // Set/remove active class
           menuItems.parent().removeClass("active").end().filter("[href='#"+id+"']").parent().addClass("active");
       }                   
    });
});

let windowResize;

$(window).resize(function () {
    let winNewWidth = $(window).width();
    let winNewHeight = $(window).height();

    if (QHGraphic.winWidth != winNewWidth || QHGraphic.winHeight != winNewHeight) {
        clearTimeout(windowResize);

        windowResize = setTimeout(function () {
            QHGraphic.winWidth = winNewWidth;
            QHGraphic.winHeight = winNewHeight;
        }, 100);
    }
});
(function () {
    if (!('serviceWorker' in navigator)) {
        return;
    }

    window.addEventListener('load', function () {
        navigator.serviceWorker.register(new URL('sw.js', document.baseURI).href).catch(function () {});
    });
})();

/**
 * fadeInUp so le cho 1 nhóm phần tử bất kỳ — ảnh, thẻ card, item danh sách... (tên giữ "Images" vì
 * lịch sử, dùng được cho mọi phần tử).
 *
 * Cách 1 — khai báo trong .twig, không cần viết JS: gắn data-reveal-items lên khung danh sách,
 * các phần tử con TRỰC TIẾP sẽ hiện lần lượt khi cuộn tới:
 *   <ul class="news-list" data-reveal-items> <li>...</li> <li>...</li> </ul>
 *   <div class="gallery-module__grid" data-reveal-items> ... </div>
 *
 * Cách 2 — gọi bằng JS:
 *   window.qhRevealImages(target, options)
 *   target            — selector string, 1 phần tử, hoặc NodeList/mảng phần tử.
 *   options.trigger    — phần tử/selector làm mốc cuộn cho CẢ NHÓM (cả nhóm hiện cùng lúc, so le).
 *                         Bỏ trống → tự gom theo thời điểm vào khung nhìn (ScrollTrigger.batch): các
 *                         phần tử cùng hàng hiện cùng lượt, hàng sau hiện khi cuộn tới — hợp với lưới dài.
 *   options.start      — điểm bắt đầu trigger (mặc định 'top 85%').
 *   options.distance   — khoảng dịch chuyển trục Y, px (mặc định 40).
 *   options.duration   — thời lượng animation, giây (mặc định .8).
 *   options.stagger    — khoảng cách giữa các phần tử (mặc định .12).
 *   options.delay      — trễ thêm trước khi chạy, giây (mặc định 0).
 *   options.ease       — easing GSAP (mặc định 'power2.out').
 *   options.once       — chỉ chạy 1 lần (mặc định true). false → cuộn ngược lên trên thì ẩn lại,
 *                         cuộn xuống chạy lại.
 *
 *   VD: window.qhRevealImages('.product-list .product-card', { distance: 30, stagger: .1 });
 *   VD: window.qhRevealImages('.partner-logo', { trigger: '.partners' });
 *
 * Lưu ý để không bị giật:
 * - KHÔNG áp dụng cho phần tử nằm trong 1 khối cha cũng đang có hiệu ứng dịch chuyển (data-reveal,
 *   GSAP riêng...) — 2 chuyển động cộng dồn sẽ giật. Khối cha chỉ nên fade opacity, hoặc bỏ hẳn.
 * - Phần tử không nên có CSS transition trên transform/opacity (CSS sẽ "đuổi theo" GSAP từng frame).
 *   Hiệu ứng hover nên đặt lên phần tử con (VD hover scale cho <img> bên trong thẻ được reveal).
 *
 * - Ẩn sẵn ngay khi DOM sẵn sàng (preloader còn che), gắn ScrollTrigger sau khi preloader ẩn.
 * - Mỗi phần tử chỉ khởi tạo 1 lần (gọi lặp không tạo animation trùng).
 * - Ảnh lazy-load xong làm đổi chiều cao → tự đo lại vị trí trigger (có gom nhóm).
 * - Tôn trọng prefers-reduced-motion và trường hợp thiếu GSAP (không ẩn gì, hiện ngay).
 */
window.qhRevealImages = (function () {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var canAnimate = !reduceMotion && typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined';
    var refreshTimer = null;

    function toArray(value) {
        if (typeof value === 'string') {
            return Array.prototype.slice.call(document.querySelectorAll(value));
        }
        if (!value) {
            return [];
        }
        return value.length !== undefined ? Array.prototype.slice.call(value) : [value];
    }

    function scheduleRefresh() {
        clearTimeout(refreshTimer);
        refreshTimer = setTimeout(function () {
            ScrollTrigger.refresh();
        }, 150);
    }

    function whenDomReady(callback) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', callback);
        } else {
            callback();
        }
    }

    function whenPageRevealed(callback) {
        if (QHGraphic.Module && typeof QHGraphic.Module.whenPreloaderDone === 'function') {
            QHGraphic.Module.whenPreloaderDone(callback);
        } else {
            whenDomReady(callback);
        }
    }

    // Phần tử đã nằm hẳn phía trên khung nhìn (VD tải lại trang giữa chừng): batch vẫn bắn onEnter
    // cho chúng, nhưng chạy tween so le ở chỗ không ai thấy chỉ làm trễ các phần tử đang hiển thị.
    // → hiện ngay bằng gsap.set, chỉ trả về những phần tử cần animate.
    function revealPassed(elements, visibleVars) {
        var passed = [];
        var pending = [];

        toArray(elements).forEach(function (el) {
            (el.getBoundingClientRect().bottom <= 0 ? passed : pending).push(el);
        });

        if (passed.length) {
            gsap.set(passed, visibleVars);
        }

        return pending;
    }

    return function (target, options) {
        options = options || {};

        var distance = options.distance !== undefined ? options.distance : 40;
        var duration = options.duration || .8;
        var stagger = options.stagger !== undefined ? options.stagger : .12;
        var delay = options.delay || 0;
        var start = options.start || 'top 85%';
        var ease = options.ease || 'power2.out';
        var once = options.once !== false;

        var els = [];

        // distance = 0 (chỉ fade) → không đụng tới transform. Sau khi hiện xong xoá transform inline:
        // translate(0, 0) còn sót lại vẫn là transform ≠ none → biến phần tử thành containing block
        // cho position: fixed bên trong (modal/lightbox lệch vị trí) + tạo stacking context thừa.
        function hide(elements) {
            gsap.set(elements, distance ? { opacity: 0, y: distance } : { opacity: 0 });
        }

        function show(elements) {
            elements = revealPassed(elements, distance ? { opacity: 1, clearProps: 'transform' } : { opacity: 1 });

            if (!elements.length) {
                return;
            }

            var vars = {
                opacity: 1,
                duration: duration,
                delay: delay,
                ease: ease,
                stagger: stagger,
                overwrite: 'auto' // chỉ huỷ tween trùng thuộc tính — true sẽ xoá cả tween khác (VD qhScrollRotate)
            };

            if (distance) {
                vars.y = 0;
                vars.clearProps = 'transform';
            }

            gsap.to(elements, vars);
        }

        // Bước 1 — ẩn sẵn khi DOM sẵn sàng (preloader còn che): nếu đợi tới lúc chạm mốc mới đặt
        // trạng thái ẩn, phần tử đang hiện sẽ bị giật về opacity 0 rồi mới hiện lại.
        function prepare() {
            if (!canAnimate) {
                return;
            }

            els = toArray(target).filter(function (el) {
                return !el.qhRevealItem;
            });

            els.forEach(function (el) {
                el.qhRevealItem = true;

                el.querySelectorAll('img').forEach(function (img) {
                    if (!img.complete) {
                        img.addEventListener('load', scheduleRefresh, { once: true });
                    }
                });
            });

            if (els.length) {
                hide(els);
            }
        }

        // Bước 2 — sau khi trang hiện ra mới gắn ScrollTrigger.
        function apply() {
            if (!canAnimate || !els.length) {
                return;
            }

            gsap.registerPlugin(ScrollTrigger);

            if (options.trigger) {
                ScrollTrigger.create({
                    trigger: options.trigger,
                    start: start,
                    once: once,
                    onEnter: function () { show(els); },
                    onLeaveBack: once ? null : function () { hide(els); }
                });
            } else {
                ScrollTrigger.batch(els, {
                    start: start,
                    once: once,
                    onEnter: show,
                    onLeaveBack: once ? null : hide
                });
            }
        }

        whenDomReady(prepare);
        whenPageRevealed(apply);
    };
})();

window.qhRevealImages('[data-reveal-items] > *');